
const Footer = () => {
  return (
    <>
      <footer class="bg-light text-center text-white new-col" >
        {/* <!-- Copyright --> */}
        <div class="text-center py-4 new-col">
          <p style={{color:"#fff"}}>© 2023 Copyright : ALL Rights Reserved</p>
        </div>
        {/* <!-- Copyright --> */}
      </footer></>
  )
}

export default Footer